import { useSelect as useCoins } from '@/pages/finance/coin/api';

interface Props {
  useName: boolean;
  value: any;
}

export const DisplayCoin = ({ value, useName = false }: Props) => {
  const { data } = useCoins({
    params: {
      pageSize: 100,
      pageIndex: 1,
    },
  });
  if (!data) {
    return <div />;
  }
  const coin = data.data.items.find((v) => (useName ? v.name === value : v.id === value));
  return <div className="text-xs">{coin?.display_name ?? '-'}</div>;
};
